// util function used to determine if an item is
// in the bottom row of `n` where n = the number
// of items in a row. Function is used to add/remove classes
// to differentiate padding/margin/border etc for items
// in the bottom row only. BW 8/1/24

interface isBottomRowOfProps {
    itemsPerRow: number;
    itemIndex: number;
    totalItems: number;
}
export default function isBottomRowOf(props: isBottomRowOfProps): boolean {
    const { itemsPerRow, itemIndex, totalItems } = props;

    // if total items is less than or equal to itemsPerRow
    // the item is by definition in the bottom row.
    if (totalItems <= itemsPerRow) return true;

    // If we have more items than can fit in a single row
    // we have to calculate the number of items in the bottom row.
    // If the remainder of totalItems % itemsPerRow = 0 , then the
    // bottom row is full. Otherwise the remainder is the number
    // of items in the bottom row.
    const numberOfItemsInBottomRow =
        totalItems % itemsPerRow > 0 ? totalItems % itemsPerRow : itemsPerRow;

    return totalItems - itemIndex <= numberOfItemsInBottomRow;
}
